// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__ETQk8","background":"Modal_background__dSaU-","inner":"Modal_inner__-HRWG"};